export const NUM_DEGREES_TOTAL = 360;
export const NUM_DEGREES_HALF = NUM_DEGREES_TOTAL / 2;

export const DEGREES_TO_RADIANS_MULTIPLIER = Math.PI / NUM_DEGREES_HALF;
export const RADIANS_TO_DEGREES_MULTIPLIER = NUM_DEGREES_HALF / Math.PI;
